export enum deviceMessageId {
  ACTION_PRINT_RECEIPT = 'print_receipt',
  ACTION_SCAN_QR = 'scan_qr',
  GET_WEB_VERSION = 'get_web_version',
  SET_WEB_VERSION = 'set_web_version',
  SCAN_QR_RESPONSE = 'scan_qr_response',
  SET_TERMINAL_ID = 'set_terminal_id',
  PRINT_LOT_CLOSURE = 'print_lot_closure',
  SET_ENVIRONMENT = 'set_environment',
  PRINT_TRANSACTION_SUMMARY = 'print_transaction_summary',
  DOWNLOAD_CLEARENCE = 'download_clearance',
  DOWNLOAD_RECEIPT = 'download_receipt',
  INVALIDATE_CACHE = 'invalidate_cache',
  SET_PLATFORM = 'set_platform',
  USER_SIGN_OUT = 'user_sign_out',
  COPY_TO_CLIPBOARD = 'copy_to_clipboard',
  DOWNLOADING_TICKET = 'downloading_ticket'
}
